import React from 'react';
import ReactDOM from 'react-dom/client';
import { HashRouter } from 'react-router-dom';
import App from './App';
import { accountService } from './Services';
import { storageHandler } from './Helpers/storage';
import "./index.css";
import 'rc-slider/assets/index.css';

window.dataLayer = window.dataLayer || [];

(function handleEmailVerificationRedirect() {
  const pathname = window.location.pathname;
  const search = window.location.search;
  
  if (pathname.includes('/account/email-verification') && search.includes('token=')) {
    const newUrl = window.location.origin + '/#/account/email-verification' + search;
    window.location.replace(newUrl);
    return; 
  }
})();

const root = ReactDOM.createRoot(document.getElementById('root'));

// Check if token exists before calling refresh
const existingToken = storageHandler.getToken();
if (existingToken) {
  accountService.refreshToken(init);
} else {
  init();
}

function init() {
  return root.render(
    <HashRouter>
      <App />
    </HashRouter>
  );
}
